import { useTranslation } from 'react-i18next';


const StayGreen = () => {
    const { t } = useTranslation();
    return (
        <div className="my-6 my-md-80">
            <div className="text-center offset-sm-1 col-sm-10 offset-md-2 c col-md-8 d-flex flex-column align-items-center">
                <img width="238px" className="mb-4" src="https://pro-static.h10hotels.com/gallery/logo-stay-green.svg" alt="Stay Green" />
                <h2 >{t("Comprometidos con el turismo responsable")}</h2>
                <p className="text-sm">
                    <strong>Stay Green</strong> {t("es el")} <strong>{t("Plan de Sostenibilidad de Vale Suites")}</strong>, {t("fruto de nuestro compromiso con la sociedad y el medio ambiente, que nace con el objetivo de impulsar y promover un modelo de turismo responsable en todos nuestros destinos.")}
                </p>
            </div>
            <ul className="mb-6 o-list-features row o-list-features_rounded">
                <li className="col-12 col-sm-6 col-md-3">
                    <span className="round">
                        <img className="w-100" src="https://pro-static.h10hotels.com/gallery/carbono-zero.svg" alt="Carbono Zero" />
                    </span>
                    <strong className="text-sm">{t("Huella de Carbono Zero")}</strong>
                </li>
                <li className="col-12 col-sm-6 col-md-3">
                    <span className="round">
                        <img className="w-100" src="https://pro-static.h10hotels.com/gallery/gestion-sostenible-agua.svg" alt="Gestión Sostenible Agua" />
                    </span>
                    <strong className="text-sm">{t("Gestión Sostenible del Agua")}</strong>
                </li>
                <li className="col-12 col-sm-6 col-md-3">
                    <span className="round">
                        <img className="w-100" src="https://pro-static.h10hotels.com/gallery/consumo-responsable.svg" alt="Consumo Responsable" />
                    </span>
                    <strong className="text-sm">{t("Consumo Responsable")}</strong>
                </li>
                <li className="col-12 col-sm-6 col-md-3">
                    <span className="round">
                        <img className="w-100" src="https://pro-static.h10hotels.com/gallery/compromiso-social.svg" alt="Compromiso Social" />
                    </span>
                    <strong className="text-sm">{t("Compromiso Social")}</strong>
                </li>
            </ul>
            <div className="c-staygreen__box">
                <p className="mb-6 text-md">
                    <span style={{ color: "rgb(0, 0, 0)" }}>{t("Vale Suites realiza las siguientes acciones específicas sobre el programa Stay Green")}:</span>
                </p>
                <div className="c-staygreen__content">
                    <div className="text-center d-flex flex-column">
                        <div className="d-flex justify-content-around w-100">
                            <figure >
                                <img alt="" width="90px" src="https://pro-static.h10hotels.com/templates/H10/src/images/logo-biosphere.png" />
                            </figure>
                            <figure >
                                <img width="90px" alt="" src="https://pro-static.h10hotels.com/templates/H10/src/icons/biosphere-5.svg" />
                                <figcaption className="green">{t("ODS destacados")}</figcaption>
                            </figure>
                        </div>
                        <a target="_blank" className="my-4 text-xs text-gray" href="https://www.biospheresustainable.com/en/community/h10-itaca/3320">{t("Certificado BHO 230/2022 RTI")}</a>
                    </div>
                    <div className="c-staygreen__text">
                        <app-read-more >
                            <div className="js-txtoverflow overflowing">
                                <ul>
                                    <li>{t("Consume electricidad de origen 100% renovable")}</li>
                                    <li>{t("Dispone de 2 cargadores para vehículos eléctricos en el parking del hotel")}&nbsp;</li>
                                    <li>{t("Dispone de tablets en Recepción para fomentar la digitalización e incentivar el ahorro de papel")}&nbsp;</li>
                                    <li>{t("Colabora con Hospital Sant Joan de Déu y Fundació Paidós con la donación de mobiliario")}</li>
                                    <li>{t("Colabora con Fundación Esperança para la reinserción laboral de personas en riesgo de exclusión social")}</li>
                                </ul>
                            </div>
                            <button type="button" className="btn btn-link btn-txtoverflow" style={{ display: "block" }}>{t("Leer más")}</button>
                        </app-read-more>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default StayGreen;
